import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { trackEvent } from '../utils/analytics';
type ExperienceCardProps = {
  id: string;
  label: string;
  title: string;
  intro: string;
  detail: string;
};
export function ExperienceCard({
  id,
  label,
  title,
  intro,
  detail
}: ExperienceCardProps) {
  const [open, setOpen] = useState(false);
  const panelId = `experience-${id}-detail`;
  return <article className="flex flex-col h-full bg-paper-raised border border-rule rounded-lg p-6 md:p-8" data-id="element-42" data-mp="1dhbedun0yys7">
      <p className="text-xs uppercase tracking-[0.12em] font-medium text-forest" data-id="element-43" data-mp="18hyr58s8rpp3">{label}</p>
      <h3 className="mt-3 font-serif text-xl md:text-[1.375rem] leading-snug text-ink" data-id="element-44" data-mp="1maof3irbz4ou">{title}</h3>
      <p className="mt-3 text-base leading-relaxed text-ink-soft" data-id="element-45" data-mp="1i8l1ool3pq0x">{intro}</p>

      <p id={panelId} hidden={!open} className="mt-4 text-base leading-relaxed text-ink-soft" data-id="element-46" data-mp="1w8ci0vz3bii3">
        {detail}
      </p>

      <div className="mt-auto pt-6" data-id="element-47" data-mp="1rakh5cggwm1r">
        <button type="button" onClick={() => {
        if (!open) trackEvent('experience_expand', {
          card: id
        });
        setOpen(value => !value);
      }} aria-expanded={open} aria-controls={panelId} className="inline-flex items-center gap-1.5 text-sm font-medium text-forest hover:text-forest-soft transition-colors duration-200" data-id="element-48" data-mp="1r7eqvtw3re4g">
          What the work involved
          <ChevronDownIcon size={16} aria-hidden="true" className={`transition-transform duration-200 ${open ? 'rotate-180' : ''}`} data-id="element-49" data-mp="2p0a3bmvh56ca" />
        </button>
      </div>
    </article>;
}